export default {
    assign_billing_account_title: "Asignar/Desasignar Cuenta de Facturación",
    assign_billing_account_label: "Cuenta de Facturación",
    assign_billing_account_input: "IMEI o serie",
    assign_billing_account_imei: "IMEI",
    assign_billing_account_serial: "Serie",
    assign_billing_account_model: "Modelo",
    assign_billing_account_assign: "Asignar",
    assign_billing_account_device_is_already_added: "El dispositivo ya está añadido",
    assign_billing_account_device_has_not_been_found: "No se ha encontrado el dispositivo",
    assign_billing_account_multiple_success_message: "La cuenta de facturación se ha asignado correctamente a los dispositivos",
    assign_billing_account_multiple_success_message_unassign: "La cuenta de facturación se ha desasignado correctamente de los dispositivos",
    assign_billing_account_error_message: "No se ha podido asignar la cuenta de facturación debido a un error",
    assign_billing_account_unassign: "Desasignar",
    assign_billing_account_current_billing_account: "Cuenta de Facturación Actual",
    assign_billing_account_select_billing_account: "Por favor, seleccione primero una Cuenta de Facturación",
}